export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function shorterString(string, maxLength) {
  return string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;
}

export function escapeRegExp(text) {
  return text?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
